import { REPEATABLE_RULE_FIELDS } from "constants/ruleEngine";
import { ConditionResult, RuleConditionRow } from "types/Models/ruleEngine";
import { getAvailableRuleOperators } from "utils/getAvailableRuleOperators";

export const getAvailableRuleFields = ({
  conditions,
  rows,
  rowIndex,
}: {
  conditions: ConditionResult[];
  rows: RuleConditionRow[];
  rowIndex: number;
}): { label: string; value: string }[] =>
  conditions
    .filter((condition) => {
      const isUsedInOtherRow = rows.some(
        ({ field }, index) => index !== rowIndex && field === condition.uuid
      );

      if (!isUsedInOtherRow) return true;
      if (!REPEATABLE_RULE_FIELDS.includes(condition.name)) return false;

      return (
        getAvailableRuleOperators({ condition, rows, rowIndex }).length > 0
      );
    })
    .map(({ name, uuid }) => ({ label: name, value: uuid }));
